import { configureStore } from "@reduxjs/toolkit";
import sliceReducer from "./slice";

export const store = configureStore({
  reducer: {
    session: sliceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
